<template >
  <span>
    <WebSite/> 
  </span>
</template>
 
<script setup>
import WebSite from '@/components/OurPages/WebSite.vue'
</script>